import * as React from 'react'
import ResizeObserver from 'resize-observer-polyfill'

type Rect = Pick<DOMRect, 'left' | 'top' | 'bottom' | 'right' | 'width' | 'height'>

export const emptyClientRect: Rect = {
  left: 0,
  top: 0,
  width: 0,
  height: 0,
  bottom: 0,
  right: 0,
}

interface Ref<T> {
  ref: (instance: null | T) => void
}

// Taken from https://codesandbox.io/embed/lp80n9z7v9
export function useMeasure<T extends Element>(clientRect = emptyClientRect): [Ref<T>, Rect] {
  const [node, ref] = React.useState<null | T>(null)
  const [bounds, set] = React.useState<Rect>(clientRect)
  const [ro] = React.useState(() => new ResizeObserver(([entry]) => set(entry.contentRect)))

  React.useLayoutEffect(() => {
    if (node) {
      set(node.getBoundingClientRect())
    }
  }, [node, set])

  React.useEffect(() => {
    if (node) ro.observe(node)
    return () => ro.disconnect()
  }, [node, ro])

  return [{ ref }, bounds]
}
